import config from 'garaje/config/environment';

export default function () {
  this.urlPrefix = config.apiHost;

  this.post(
    '/a/graphql',
    {
      data: {
        locations: [],
      },
    },
    201
  );
}
